import moment from "moment";
import { useState } from "react";
import styles from "./WorkSchedulesHeader.module.css";
import { useAppSelector } from "hooks/reduxHooks";
import WorkScheduleDatePicker from "./WorkScheduleDatePicker";
import WorkScheduleMonthPicker from "./WorkScheduleMonthPicker";

export default function WorkSchedulesHeader() {
  const selectedDate = useAppSelector(
    (state) => state.workSchedule.selectedDate
  );

  const [selectedMonth, setSelectedMonth] = useState(
    moment(selectedDate).format("MMMM YYYY")
  );

  const [selectedDatePicker, setSelectedDatePicker] =
    useState(moment(selectedDate).clone().weekday(1).format("YYYY-MM-DD"));

  return (
    <div className={styles.workSchedulesHeaderContainer}>
      <WorkScheduleMonthPicker
        selectedMonth={selectedMonth}
        setSelectedMonth={setSelectedMonth}
        setSelectedDatePicker={setSelectedDatePicker}
      />
      <WorkScheduleDatePicker
        setSelectedMonth={setSelectedMonth}
        selectedDatePicker={selectedDatePicker}
        setSelectedDatePicker={setSelectedDatePicker}
      />
    </div>
  );
}
